import { PageTable } from '@components-common/layouts';
import { layoutWorkspace } from '../_common/layout.workspace';
import { ConfigSection, CreateTemplate } from '../../components-fabric';
import { PageFormToolbar } from '../../components-common/layout/views/PageFormToolbar';
import { ResourcesForm } from '../../components-domain/education-domain/courses/ResourcesForm';
import { getResourcesValidationSchema } from '../../components-domain/education-domain/courses/resources.schema';
import {
  deleteTableRow,
  downloadFile,
} from '../../components-common/_shared/actionButton.helper';

/**
 * Configuration Object: resourceEntityConfig
 *
 * This object contains the configuration for the resource entity.
 * It includes columns, data source, layout, template, component, form, default values, endpoints, and schema.
 */
export const resourceEntityConfig = {
  columns: [
    { id: 'name', dataField: 'name' },
    'description',
    { id: 'fileExtension', text: 'Type' },
    'createdDate',
  ],
  source: '/mediasms/mediaitemresources',
  layout: layoutWorkspace,
  template: '/mediasms/mediaitemresources',
  Component: PageFormToolbar,
  form: ResourcesForm,
  empty: {
    name: '',
    // Leave this comment commented as I am not sure if it should be this way to upload resources
    // state: 'ACTIVE',
    // modifiedDate: new Date(Date.now()),
    // createdDate: new Date(Date.now()),
    // type: 'LINK',
    // url: '',
    subjectId: '',
  },
  endpoints: '/mediasms/mediaitemresources?subjectId={courseId}',
  schema: {},
};

/**
 * Configuration Object: courseResourcesScreens
 *
 * This object contains the configuration for the course resources screens.
 * It includes roles, layout, URL parameters, columns, and actions.
 */
export const courseResourcesScreens: ConfigSection = {
  id: 'resources',
  path: 'resources',
  title: 'Resources',
  layout: layoutWorkspace,
  screens: [
    {
      id: 'index',
      path: '.',
      roles: ['STUDY_DIRECTOR', 'LECTURER', 'STUDENT'],
      left: [
        {
          id: 'create_new',
          kind: 'create_new',
          roles: ['STUDY_DIRECTOR', 'LECTURER'],
        } as any,
      ],
      Component: PageTable,
      source: resourceEntityConfig.source,
      urlParams: {
        subjectId: '{id}',
      },
      tmp: 'index',
      columns: resourceEntityConfig.columns,
      empty: resourceEntityConfig.empty,
      actions: [
        {
          id: 'download',
          onClick: (props: any) =>
            downloadFile(props.row.url, props.row.fileName),
          displayTooltip: true,
          tooltipText: 'Download resource',
        },
        {
          id: 'delete',
          roles: ['STUDY_DIRECTOR', 'LECTURER'],
          actionToDispatch: {
            payload: {
              endpointToDelete: resourceEntityConfig.template,
            },
          },
          displayTooltip: true,
          tooltipText: 'Delete resource',
        },
      ],
    } as any,
    {
      id: 'create',
      path: 'new',
      tmp: 'create',
      roles: ['STUDY_DIRECTOR', 'LECTURER'],
      left: ['create'],
      schema: getResourcesValidationSchema(),
      Component: resourceEntityConfig.Component,
      form: resourceEntityConfig.form,
      empty: resourceEntityConfig.empty,
    } as CreateTemplate,
  ],
};
